import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { AUD_MOBILE_REDESIGN_MAINPAGE_HEADER } from '../constants/experiments';
import { selectExperiments } from '../selectors/experiments';
import { useApplicationContext } from '../utils/applicationContext';
import { getExperiment } from '../utils/experiments';

const REDESIGN_GROUPS_WITHOUT_DIVIDER_ON_MAIN = ['B', 'C'];

export function useHeaderNeedDivider(): boolean {
  const { custom } = useApplicationContext();

  const { platform, anonymousUserId, mobileAppId } = custom;

  const isWebPlatform = platform === 'desktop' || platform === 'mobile' || platform === 'searchBot';
  const isExperimentsIgnore = (isWebPlatform && !anonymousUserId) || (!isWebPlatform && !mobileAppId);

  const experiments = useSelector(selectExperiments);

  const [isMainPage, setIsMainPage] = useState(false);

  useEffect(() => {
    setIsMainPage(window.location.pathname === '/');
  }, []);

  return useMemo(() => {
    if (isExperimentsIgnore) {
      return true;
    }

    const experimentGroup = getExperiment(experiments, AUD_MOBILE_REDESIGN_MAINPAGE_HEADER)?.group ?? '';
    const isRedesignWithoutDivider = REDESIGN_GROUPS_WITHOUT_DIVIDER_ON_MAIN.includes(experimentGroup);

    return !isMainPage || !isRedesignWithoutDivider;
  }, [isExperimentsIgnore, isMainPage, experiments]);
}
